




import json from './organization.json';

export default {
  name: 'OrganizationJsonLd',
  computed: {
    // Organization schema.org for SEO purpose - to show a search widget on company name,
    // could be rendered only on main page
    json: () => JSON.stringify(json),
  },
};
